import axios from "../config/axios";
import Constants from "../data/Constants";

export const getAllMentorReports = async (filters, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.REPORT.ALL, {
      params: filters,
    })
    .then((res) => {
      return res.data.result;
    });
};
